/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { SettingsUserInfoAction, SettingsUserInfoActionType } from '../actions/settingsUserInfoActions';
import { DetailedUserDto } from '../api/users/usersClient.typings';

export interface SettingsUserInfoState {
    isLoading: boolean;
    userInfo: DetailedUserDto;
}

const initialState: SettingsUserInfoState = {
    isLoading: false,
    userInfo: null,
};

export function settingsUserInfoReducer(
    state: SettingsUserInfoState = initialState,
    action: SettingsUserInfoAction,
): SettingsUserInfoState {
    switch (action.type) {
        case SettingsUserInfoActionType.OPEN_SETTINGS_USER_INFO_PAGE:
            return {
                ...state,
                isLoading: true,
            };

        case SettingsUserInfoActionType.FETCH_USER_INFO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                userInfo: action.payload,
            };

        case SettingsUserInfoActionType.UPDATE_USER_INFO:
            return {
                ...state,
                isLoading: true,
            };

        case SettingsUserInfoActionType.FETCH_USER_INFO_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case SettingsUserInfoActionType.EXIT_SETTINGS_USER_INFO_PAGE:
            return {
                ...state,
                userInfo: null,
            };

        default:
            break;
    }

    return state;
}
